import { useLocation } from "react-router-dom"

export function useQuery() {
	const location = useLocation()
	const param = location.pathname.split("/").pop()
	const newArray = []
	newArray.push(param)
	return param
}
